import React, { useEffect, useState } from "react";
import "./Gallery.scss";
import { Button, Flex, Modal, Tabs } from "antd";
import GalleryContent from "@components/GalleryContent/GalleryContent";
import Helpers from "@utils/Helpers";
import { useGallery } from "contexts/GalleryContext";
import ImageCropper from "@components/ImageCropper/ImageCropper";
interface IGallery {
  isGalleryOpen: boolean;
  submitGallery: (selected: any[]) => void;
  cancelGallery: () => void;
  limit: number;
  activeKey?: string;
}

const PFOFILE_GALLERY_LIMIT = 3;
const BANNER_GALLERY_LIMIT = 2;
const PRODUCT_GALLERY_LIMIT = 10;
const HAY2U_GALLERY_LIMIT = 5;
const VIDEO_GALLERY_LIMIT = 1;

const Gallery: React.FC<IGallery> = ({
  isGalleryOpen,
  submitGallery,
  cancelGallery,
  limit,
  activeKey,
}) => {
  const [selectedImg, setSelectedImg] = useState<any[]>([]);
  const [activeTab, setActiveTab] = useState("1");
  const { gallery, updateGallery } = useGallery();
  const [isSelectedAll, setIsSelectedAll] = useState<boolean>(false);

  useEffect(() => {
    setActiveTab(activeKey ? activeKey : "1");
  }, [activeKey]);

  const handleSetGalleryImages = (type: string, data: string[]) => {
    updateGallery({ ...gallery, [type]: data });
  };

  const handleSubmitGallery = () => {
    if (selectedImg.length > limit) {
      Helpers.notification.warning(
        `Please choose maximum ${limit} ${limit > 1 ? "images" : "image"}`
      );
      return;
    }
    cancelGallery();
    submitGallery(selectedImg);
    setSelectedImg([]);
    setIsSelectedAll(false);
  };

  const countAvailableSlot = (gallery: any[]): number => {
    if (gallery) {
      let count = 0;
      gallery.forEach((item) => {
        if (item.is_default == false) {
          count += 1;
        }
      });
      return count;
    }
    return 0;
  };

  const galleryMenu: any[] = [
    {
      id: "1",
      label: (
        <GalleryTabLabel
          type="Profile"
          amount={countAvailableSlot(gallery?.profile)}
          limit={PFOFILE_GALLERY_LIMIT}
        />
      ),
      children: (
        <GalleryContent
          type={"profile"}
          data={gallery?.profile}
          setData={handleSetGalleryImages}
          selectedImg={selectedImg}
          setSelectedImg={setSelectedImg}
          isSelectedAll={isSelectedAll}
          limit={PFOFILE_GALLERY_LIMIT}
          setIsSelectedAll={setIsSelectedAll}
        />
      ),
    },
    {
      id: "2",
      label: (
        <GalleryTabLabel
          type="Banner"
          amount={countAvailableSlot(gallery?.banner)}
          limit={BANNER_GALLERY_LIMIT}
        />
      ),
      children: (
        <GalleryContent
          type={"banner"}
          data={gallery?.banner}
          setData={handleSetGalleryImages}
          selectedImg={selectedImg}
          setSelectedImg={setSelectedImg}
          isSelectedAll={isSelectedAll}
          limit={BANNER_GALLERY_LIMIT}
          setIsSelectedAll={setIsSelectedAll}
        />
      ),
    },
    {
      id: "3",
      label: (
        <GalleryTabLabel
          type="Product"
          amount={countAvailableSlot(gallery?.product)}
          limit={PRODUCT_GALLERY_LIMIT}
        />
      ),
      children: (
        <GalleryContent
          type={"product"}
          data={gallery?.product}
          setData={handleSetGalleryImages}
          selectedImg={selectedImg}
          setSelectedImg={setSelectedImg}
          isSelectedAll={isSelectedAll}
          limit={PRODUCT_GALLERY_LIMIT}
          setIsSelectedAll={setIsSelectedAll}
        />
      ),
    },
    {
      id: "4",
      label: (
        <GalleryTabLabel
          type="H2U"
          amount={countAvailableSlot(gallery?.h2u)}
          limit={HAY2U_GALLERY_LIMIT}
        />
      ),
      children: (
        <GalleryContent
          type={"h2u"}
          data={gallery?.h2u}
          setData={handleSetGalleryImages}
          selectedImg={selectedImg}
          setSelectedImg={setSelectedImg}
          isSelectedAll={isSelectedAll}
          limit={HAY2U_GALLERY_LIMIT}
          setIsSelectedAll={setIsSelectedAll}
        />
      ),
    },
    {
      id: "5",
      label: (
        <GalleryTabLabel
          type="Video"
          amount={countAvailableSlot(gallery?.video)}
          limit={VIDEO_GALLERY_LIMIT}
        />
      ),
      children: (
        <GalleryContent
          type={"video"}
          data={gallery?.video}
          setData={handleSetGalleryImages}
          selectedImg={selectedImg}
          setSelectedImg={setSelectedImg}
          isSelectedAll={isSelectedAll}
          limit={VIDEO_GALLERY_LIMIT}
          setIsSelectedAll={setIsSelectedAll}
        />
      ),
    },
  ];
  return (
    <>
      <Modal
        className="Gallery"
        open={isGalleryOpen}
        onCancel={cancelGallery}
        footer={false}
      >
        <div className="gallery-title">Gallery</div>
        <div className="gallery-tab">
          <Tabs
            activeKey={activeTab}
            onChange={(key) => setActiveTab(key)}
            tabPosition={"left"}
            items={galleryMenu.map((item, i) => {
              return {
                label: item.label,
                key: item.id,
                children: item.children,
              };
            })}
          />
        </div>
        <div className="gallery-footer">
          <Button className="save-btn" onClick={handleSubmitGallery}>
            Select
          </Button>
        </div>
      </Modal>
    </>
  );
};

const GalleryTabLabel: React.FC<any> = ({ type, amount, limit }) => {
  return (
    <div className="GalleryTabLabel">
      <Flex align="center">
        <div className="label">{type}</div>
        <div className="limit">
          {amount}/{limit}
        </div>
      </Flex>
    </div>
  );
};

export default Gallery;
